export class OrganiserPaymentData {
  organiserId?: number;
  taxNumber?: string;
  paysPDV?: boolean;
  exemptionText?: string;
  defaultCurrency?: number;
  iban?: string;
  swift?: string;
  bankName?: string;
  bankAddress?: string;
  bankPlace?: string;
  bankZip?: string;

  constructor() {
    this.organiserId = undefined;
    this.taxNumber = undefined;
    this.paysPDV = undefined;
    this.exemptionText = undefined;
    this.defaultCurrency = undefined;
    this.iban = undefined;
    this.swift = undefined;
    this.bankName = undefined;
    this.bankAddress = undefined;
    this.bankPlace = undefined;
    this.bankZip = undefined;
  }
}
